import { QueryClient } from '@tanstack/react-query';

// App.tsx
const queryClient = new QueryClient();

export { queryClient };
